import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FooterMarketingComponent } from './footer-marketing.component';
import { TranslateModule } from '@xref/ngx';

@NgModule({
  declarations: [FooterMarketingComponent],
  exports: [FooterMarketingComponent],
  imports: [
    CommonModule,
    TranslateModule
  ]
})
export class FooterMarketingModule {}
